export default {
  translation_key: 'Value',
};
